'use strict';

module.exports = require('../src/reader/readZip');
